import React from "react";
import Landingpage from "../../Components/Landing Page/landingpage";
import Event from '../../Components/Events/event';

const Home = () => {
    return (
        <div>
            <Landingpage />
            <Event />
        </div>
    );
};
export default Home;